import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleCurrentModal } from "../../../store/actions";
import FiatWithdraw from "components/Withdraw/Fiat/FiatWithdraw";
import Mt5Withdraw from "components/Withdraw/MT5/Mt5";
import SelectWithdrawalMethodModal from "./SelectWithdrawalMethodModal";
import { getCountSaddadDepositsStart } from "store/forex/cp/actions";

function WithdrawModals() {
  const dispatch = useDispatch();
  const { currentModal, saddadDepositsCount } = useSelector((state) => ({
    currentModal: state.Layout.currentModal,
    saddadDepositsCount: state.forex.cp.transactions.saddadDepositsCount,
  }));
  useEffect(() => {
    if (
      ["fiatWithdraw", "mt5Withdraw"].includes(currentModal)) {
      dispatch(getCountSaddadDepositsStart());
    }
  }, [currentModal]);
  return (
    <>
      {currentModal === "fiatWithdraw" && <FiatWithdraw
        isOpen={currentModal === "fiatWithdraw"}
        saddadShow= {saddadDepositsCount > 0}
        toggleOpen={() => {
          dispatch(toggleCurrentModal(""));
        }}
      ></FiatWithdraw>}
      {currentModal === "mt5Withdraw" && <Mt5Withdraw
        isOpen={currentModal === "mt5Withdraw"}
        saddadShow={saddadDepositsCount > 0}
        toggleOpen={() => {
          dispatch(toggleCurrentModal(""));
        }}
      >
      </Mt5Withdraw>}
      {currentModal === "selectWithdrawalMethodModal" && <SelectWithdrawalMethodModal
        isOpen={currentModal === "selectWithdrawalMethodModal"}
        toggleOpen={() => {
          dispatch(toggleCurrentModal(""));
        }}
      ></SelectWithdrawalMethodModal>}
    </>
  );
}

export default WithdrawModals;
